import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
//import { HeaderHelperOptions } from '@base-interfaces/header-helper';
var MainSidebarService = /** @class */ (function () {
    //titleSet: Subject<any> = new Subject<any>();
    ///displayHeader: Subject<any> = new Subject<any>();
    function MainSidebarService() {
        //iconSet: Subject<HeaderHelperOptions> = new Subject<HeaderHelperOptions>();
        this.panelOpen = new Subject();
        this.toggleSidebarCollapsed = new Subject();
    }
    /**
     * Notify to side panel that should be closed
     */
    MainSidebarService.prototype.panelCollapsed = function () {
        this.toggleSidebarCollapsed.next();
    };
    MainSidebarService.ngInjectableDef = i0.defineInjectable({ factory: function MainSidebarService_Factory() { return new MainSidebarService(); }, token: MainSidebarService, providedIn: "root" });
    return MainSidebarService;
}());
export { MainSidebarService };
